import React from "react";

export default function LayoutLogin(props) {
  return (
    <div className="transition-all ease-linear duration-150 w-full flex bg-black h-full min-h-screen items-center justify-center py-10">
      <div className="w-full md:w-3/12 py-2 px-6 md:px-2">{props.children}</div>
    </div>
  );
}
